import type { JSX } from 'react';
import { useStore } from 'zustand';
import { nativeToolsStore } from '../../../nativeTools/toolsPresence';

/** OBS publishes through the ompeer-tools desktop app; Studio only points the way. */
export function ObsModeCard(): JSX.Element {
  const connected = useStore(nativeToolsStore, state => state.connected);
  return (
    <section id="sm-obs" className="sm-card sm-obs" aria-label="OBS Mode">
      <div className="sm-card-head">
        <h3 className="sm-card-title">OBS Mode</h3>
      </div>
      <p className="ui-dim">
        Stream directly from OBS with ompeer-tools. Connect your OMP account in the app, choose “Transmitir desde OBS…”,
        and use the server and key supplied by the app. The app publishes to OMP; Studio can stay closed.
      </p>
      {connected === false && <a className="ui-btn" href="https://ompeer.com/downloads" target="_blank" rel="noopener noreferrer">Download ompeer-tools</a>}
    </section>
  );
}
